import React from "react";

export default React.createContext({
  openTabs: [],
  uid:'',
  view:'',
  processCompareView:'',
  network:{},
  handleAddTab: () => {},
  handleRemoveTab: () => {},
  handleUid: () => {},
  selectFilter:() => {},
  handleEvents_cases: () => {},
  actionFilter: () => {},
  selectView: () => {},
  handleAutoSave:() => {},
  handleListOfVariants:() => {},
  handleConformanceCheckingData: () => {},
  handleWorkspace:() => {},
  handleAnalysis:() => {},
  handleSelectedWorkspaceInfo:() => {},
  handleSelectedVariantsFromFilter:() => {},
  handleCompareId:() => {},
  handleCompareColor:() => {},
  handleChangeVariantsFilter:() => {},
  handleDataChartCompare:() => {},
  conformanceCheckingData: {},
  handleLayerList:() => {},
  handleAllowGetTab:() => {},
  handleLostWorkspaceDataConnector: () => {},
  onlineStatus: true,
  handleSaveAnalysisStatus: () => {},
  handleSaveWorkspaceStatus: () => {},
  handleSaveGenerateBpmnFilters: () => {},
  handleExplorerActiveTab: () => {},
  handleFiltersSubmitClicked: () => {},
  handleHasSavedFilters: () => {}
});
